export let TypeInfo;

(function (TypeInfo) {
  TypeInfo["ReqInfoApp"] = "REQ.INFO.APP";
  TypeInfo["ReqInfoRegion"] = "REQ.INFO.REGION";
  TypeInfo["ReqInfoLocation"] = "REQ.INFO.LOCATION";
  TypeInfo["ReqInfoUser"] = "REQ.INFO.USER";
  TypeInfo["ReqInfoRegionName"] = "REQ.INFO.REGION_NAME";
  TypeInfo["ResInfoApp"] = "RES.INFO.APP";
  TypeInfo["ResInfoRegion"] = "RES.INFO.REGION";
  TypeInfo["ResInfoUser"] = "RES.INFO.USER";
  TypeInfo["ResInfoRegionName"] = "RES.INFO.REGION_NAME";
})(TypeInfo || (TypeInfo = {}));